import { colors } from "@theme/theming";
import styled from "styled-components";

export default styled.div`
	background-color: ${colors.gray.g100}30;
	padding: 32px;
	border: 2px solid ${colors.gray.g200};
	border-radius: 10px;
`;
